<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <form novalidate @submit.prevent="submit"> 

          <Input 
            type="text" 
            @on-input="inputEmail" 
            :isError="invalidEmail()"
            :textError="errorTextEmail"
            caption="Email:"
          />

          <div class="form-group text-center">
            <router-link :to="{ name: 'Login' }" class="d-inline" > Войти </router-link> | 
            <router-link :to="{ name: 'Registration' }" class="d-inline" > Регистрация </router-link>
          </div>
              
          <button class="btn btn-primary" type="button" disabled v-if="showWait">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Загрузка...
          </button>
          <button type="submit" class="btn btn-primary" v-else>
            Отправить
          </button>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Input.vue'
import { minLength, testEmail } from '@/utils/Validate.js'

export default {
  components: {
    Input
  },
  data() {
    return {
      email: '',
      emailError: {
        minLength: false,
        wrongEmail: false,
        noExistsEmail: false
      },
      showWait: false
    }
  },
  computed: {
    errorTextEmail: function() {
      let error = "";
      if (this.emailError.minLength) error = "Поле email не должно быть пустым!"
      if (this.emailError.wrongEmail) error = "Введите корректный email!"
      if (this.noExistsEmail) error = "Указанный email не зарегистрирован!"
      return error;
    },
  },
  methods: {
    inputEmail(value) {
      this.emailError.minLength = minLength(value)
      this.emailError.wrongEmail = false
      this.emailError.noExistsEmail = false
      this.email = value
    },
    invalidEmail() {
      for (let key in this.emailError) {
        if (this.emailError[key]) return true
      }
      return false
    },
    submit() {
      this.emailError.minLength = minLength(this.email)
      this.emailError.wrongEmail = !testEmail(this.email)

      if (!this.invalidEmail()) {
        // отправка
        this.showWait = true;
        const formData = new FormData();
        formData.append('email', this.email)

        this.$store.dispatch('resetPassword', formData)
        .then((/*res*/) => { // нужно получать от сервера код: ок или email не соществует
          this.showWait = false;
          /* if (res.codeError === 0) */this.$router.push({ name: 'Login' })
        })
        .catch(() => {
          this.showWait = false;
        })
      }
    }
  }
  
}
</script>